export default __webpack_public_path__ + "static/media/pickupIcon.62efbf65.jpg";